import classNames from 'classnames'

import { Modal, Button, CustomField } from '@/shared'
import { type IUpdatePasswordDto } from '@App/types/authType'

import style from './ChangePasswordModal.module.scss'
import { useFields } from './useFields'

interface IProps {
    show: boolean
    onClose: () => void
    onChangePassword: (dto: IUpdatePasswordDto) => void
}

export const ChangePasswordModal = (props: IProps) => {
    const { show, onClose, onChangePassword } = props

    const {
        oldPassword,
        oldPasswordError,
        onHandleChangeOld,
        onHandleFocusOld,
        onZeroOld,
        newPassword,
        newPasswordError,
        onHandleChangeNew,
        onHandleFocusNew,
        onZeroNew,
        isValidFields,
        onInitializeFields
    } = useFields()

    const onCloseModal = () => {
        onInitializeFields()
        onClose()
    }

    const actions = [
        {
            title: 'Сменить',
            callback: () => onChangePassword({ newPassword: newPassword.value, oldPassword: oldPassword.value }),
            disabled: isValidFields,
            className: 'save'
        },
        {
            title: 'Отменить',
            callback: onCloseModal,
            disabled: false,
            className: 'close'
        }
    ]
    return (
        <Modal show={show}>
            <div className={style.container}>
                <div className={style.fields}>
                    <CustomField
                        value={oldPassword.value}
                        placeholder={oldPassword.placeholder}
                        name={oldPassword.name}
                        onFocus={onHandleFocusOld}
                        onChange={onHandleChangeOld}
                        onZeroText={onZeroOld}
                        error={oldPasswordError}
                    />
                    <CustomField
                        value={newPassword.value}
                        placeholder={newPassword.placeholder}
                        name={newPassword.name}
                        onFocus={onHandleFocusNew}
                        onChange={onHandleChangeNew}
                        onZeroText={onZeroNew}
                        error={newPasswordError}
                    />
                </div>
                <div className={style.actions}>
                    {actions.map((action) => {
                        const { title, callback, className, disabled } = action
                        return (
                            <Button
                                key={title}
                                onClick={callback}
                                className={classNames(style.btn, style[className])}
                                disabled={disabled}
                            >
                                {title}
                            </Button>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
